/**
 * Product config injected by each app before render.
 *
 * Shared modules call ``getConfig()`` instead of importing
 * ``react_frontend/src/config.js`` or ``curedia_frontend/src/config.js``.
 */
let current = null;

export function configureWebCore(config) {
  current = config || null;
  return current;
}

export function getConfig() {
  return current;
}
